import { jsx } from "@ecopages/jsx/jsx-runtime";
import "./form.script";
export function RuiForm({
  children,
  defaultValues,
  defaultValuesData,
  resolver,
  reValidateMode,
  onSubmit,
  action,
  method,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-form", {
    ...props,
    action,
    method,
    reValidateMode,
    "attr:revalidate-mode": reValidateMode,
    "prop:defaultValues": defaultValues,
    "prop:resolver": resolver,
    "prop:onSubmit": onSubmit,
    data: {
      defaultValues: defaultValuesData ?? (defaultValues !== void 0 ? JSON.stringify(defaultValues) : void 0)
    },
    children: /* @__PURE__ */jsx("form", {
      class: "rui-form",
      "data-ref": "form",
      noValidate: true,
      action,
      method,
      children
    })
  });
}